import { render, staticRenderFns } from "./SearchBasic.vue?vue&type=template&id=77804a69&"
import script from "./SearchBasic.vue?vue&type=script&lang=js&"
export * from "./SearchBasic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports